import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../utils/api';
import { initFeatherIcons } from '../../utils/featherIcons';
import Sidebar from './Sidebar';
import Header from './Header';
import Breadcrumbs from './Breadcrumbs';
import '../../pages/dashboard/Dashboard.css';

const DashboardLayout = ({
  children,
  breadcrumbs = [],
  searchTerm = '',
  onSearchChange = () => { },
  className = ''
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Check authentication on component mount
  useEffect(() => {
    if (!isAuthenticated()) {
      window.location.href = '/login';
      return;
    }
  }, []);

  // Initialize Feather icons after component mounts and updates
  useEffect(() => {
    initFeatherIcons();
  });

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleMobileSidebarToggle = () => {
    setSidebarCollapsed(true);
  };

  return (
    <div className="dashboard-container">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={handleSidebarToggle}
      />

      <div className="dashboard-main">
        <Header
          searchTerm={searchTerm}
          onSearchChange={onSearchChange}
          onMobileMenuToggle={handleMobileSidebarToggle}
        />

        <main className={`dashboard-content ${className}`}>
          <Breadcrumbs items={breadcrumbs} />
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;